export default {
  user: {},
  token: '',
  franchisee: {},
  cities: [],
  city: {},
  permissions: [],
  plans: [],
};
